export enum ProjectName {
  Heorot = 'Heorot',
  Bareka = 'Bareka',
  Rekensprint = 'Rekensprint',
  ATR = "ATR"
}
